/* eslint-disable @typescript-eslint/no-misused-promises */
import Image from 'next/image'
import { HomeComponentType } from '@components/HomePage/utils/HomeComponentType'
import { ProductCardButton } from '@components/Home/ProductCardButton/ProductCardButton'
import { Domain } from '@enums/Domain'
import { IBannerProps } from '@interfaces/landingWidget'
import Link from 'next/link'
import { trackEvent } from '@acko-tech/building-blocks.ui.acko-analytics'
import { domainConfig } from '@configs/domain.config'
import { thalaBannerMock } from 'homepageMock'
import styles from './productbanner.module.scss'

export interface IProductBannerProps {
  data: IBannerProps
}

const AckoDriveProductBanner = ({ data }: IProductBannerProps) => {
  const handleBannerClick = async () =>
    await trackEvent(domainConfig[Domain.ACKO].events.homePage, { type: thalaBannerMock?.trackEventType })

  return (
    <div id={HomeComponentType.ProductBanner}>
      <div className={styles.ackoDriveProductContainer}>
        <Link
          className={styles.banner}
          href={thalaBannerMock?.buttonLink}
          target="_blank"
          rel="noopener noreferrer"
          onClick={handleBannerClick}>
          <div className={styles.bannerContent}>
            <div className={styles.bannerTexts}>
              <div className={styles.bannerHeading}>{thalaBannerMock?.heading}</div>
              <div className={styles.bannerSubHeading}>{thalaBannerMock?.subHeading}</div>
            </div>
            <div className={styles.bannerButton}>{thalaBannerMock?.buttonText}</div>
          </div>
        </Link>
        <span className={styles.ackoDriveProductHeading}>{data?.heading}</span>
        <div className={styles.ackoDriveProductSubHeading}>
          <span className={styles.subHeadingText}>{data?.subHeading}&nbsp;</span>
          <Image src={data?.logoSrc} width={90} height={28} alt="product logo" className={styles.logo} />
        </div>
        <div className={styles.ackoDriveProductWrapper}>
          {data?.productCards?.data?.map(productItem => (
            <ProductCardButton
              key={productItem?.id}
              product={productItem?.attributes}
              imageSize={136}
              domain={Domain.ACKODRIVE}
            />
          ))}
        </div>
        <div className={styles.disclaimer}>{data?.productsDisclaimer}</div>
      </div>
    </div>
  )
}

export default AckoDriveProductBanner
